package com.ilussobsa.views

import com.ilussobsa.*
import com.ilussobsa.Strings
import com.ilussobsa.sdk.*
import com.lightningkite.UUID
import com.lightningkite.kiteui.*
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.children
import com.lightningkite.lightningdb.*
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*

@Routable("live-auction/{id}/runlist")
class LiveAuctionRunlistScreen(val id: UUID) : Page {

    override fun ViewWriter.render() = col {
        val auction = remember { currentSession().auctionLane.get(id)() }
        val live = remember { currentSession().liveAuctionData.watch(id)() }
        val runlistMeta = remember {
            val isNextAuction = currentSession().auctionLane.query(Query(
                orderBy = sort { it.scheduledStart.ascending() },
                limit = 1
            ))().firstOrNull()?._id == id
            currentSession().vehicle.watch(
                Query(
                    orderBy = sort { it.orderingValue.ascending() },
                    limit = 1000,
                    condition = if (isNextAuction) {
                        auction.awaitNotNull().runlist or auction.awaitNotNull().submittedAwaitingAssignment
                    } else {
                        auction.awaitNotNull().runlist
                    }
                )
            )
        }
        val runlist = remember { runlistMeta()() }
        val jumpToCurrent = BasicListenable()
        padded - frame {
            compact - important - button {
                centered - text(Strings.jumpToCurrent)
                ::shown { live() != null }
                onClick { jumpToCurrent.invokeAll() }
            }
        }
        expanding - padded - recyclerView {
            children(
                items = runlist,
                id = { it._id }
            ) {
                compact - link {
                    dynamicTheme {
                        if (live()?.currentVehicle == it()._id) SelectedSemantic
                        else null
                    }
                    sellingLotShortDetails(it)
                    ::to {
                        val id = it()._id
                        { VehicleDetailScreen(id) }
                    }
                }
            }
            reactiveScope {
                rerunOn(jumpToCurrent)
                val current = live.awaitOnce()?.currentVehicle
                val index = runlist.awaitOnce().indexOfFirst { it._id == current }
                if (index != -1) scrollToIndex(index, Align.Start)
            }
        }
    }
}